export default __webpack_public_path__ + "static/media/zoom_in.95ec8a52.svg";